import React from 'react';
import { useTranslation } from 'react-i18next';

const STATUS_OPTIONS = ['', 'ok', 'error', 'partial'];

export default function AuditFiltersBar({
  value,
  onChange,
  showStatus = true,
  showTraceId = true,
  extra = null,
}) {
  const { t } = useTranslation();
  const v = value || {};

  const set = (k, val) => onChange({ ...v, [k]: val });

  return (
    <div className="flex flex-wrap gap-3 items-end mb-4 pb-4 border-b border-border-subtle">
      <Field label={t('traceability:filters.from')}>
        <input
          type="datetime-local"
          value={v.from || ''}
          onChange={(e) => set('from', e.target.value)}
          className="bg-surface border border-border-strong rounded px-2 py-1 text-sm text-ink"
        />
      </Field>
      <Field label={t('traceability:filters.to')}>
        <input
          type="datetime-local"
          value={v.to || ''}
          onChange={(e) => set('to', e.target.value)}
          className="bg-surface border border-border-strong rounded px-2 py-1 text-sm text-ink"
        />
      </Field>
      {showTraceId && (
        <Field label={t('traceability:filters.traceId')}>
          <input
            type="text"
            maxLength={64}
            value={v.trace_id || ''}
            onChange={(e) => set('trace_id', e.target.value.replace(/[^a-f0-9-]/gi, ''))}
            placeholder="hex"
            className="bg-surface border border-border-strong rounded px-2 py-1 text-sm text-ink w-56"
          />
        </Field>
      )}
      {showStatus && (
        <Field label={t('traceability:filters.status')}>
          <select
            value={v.status || ''}
            onChange={(e) => set('status', e.target.value)}
            className="bg-surface border border-border-strong rounded px-2 py-1 text-sm text-ink"
          >
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt || 'all'} value={opt}>
                {opt ? t(`traceability:status.${opt}`) : t('traceability:filters.all')}
              </option>
            ))}
          </select>
        </Field>
      )}
      {extra}
      <button
        type="button"
        onClick={() => onChange({})}
        className="text-label tracking-widest text-ink-muted hover:text-accent-text px-3 py-1"
      >
        {t('traceability:filters.clear')}
      </button>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-label tracking-widest text-ink-muted uppercase">{label}</span>
      {children}
    </label>
  );
}

export function toQueryParams(v) {
  const out = {};
  if (!v) return out;
  if (v.from) out.from = new Date(v.from).toISOString();
  if (v.to) out.to = new Date(v.to).toISOString();
  if (v.trace_id) out.trace_id = v.trace_id;
  if (v.status) out.status = v.status;
  return out;
}
